import { FC } from "react";

interface RequiredAfteriskProps {}
export const RequiredAsterisk: FC<RequiredAfteriskProps> = (props) => {
  return <span style={{ color: 'red', marginRight: '4px', display: 'inline-block', fontSize: '14', lineHeight: '1' }}>*</span>;
};
